const CONFIG = {
  DIAL_OFFSET_DEG: 9,
  DEGREES_PER_FRAME: -18,
  TRANSITION_MS: 100,
  SNAP_MAX_MS: 300,
  SNAP_BASE_MS: 150,
  SNAP_EASING: 'cubic-bezier(0.23, 0.07, 0.25, 1)',
  VELOCITY_WINDOW: 5,
};

const SIMULATIONS = [
  {
    id: 'provia',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Asset-1_4x-5.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Provia.jpg?v=1779881555',
    title: 'PROVIA',
    titleColor: '#ffffff',
    desc: 'PROVIA delivers balanced colors, natural contrast, and exceptional versatility for everyday photography. A perfect all-round Film Simulation for every scene.',
  },
  {
    id: 'sepia',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/sepia-9_3a2e8aad-0d14-4a52-9221-a9fe0eb927f8.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/SEPIA.jpg?v=1779881555',
    title: 'SEPIA',
    titleColor: '#9b7a4b',
    desc: 'SEPIA adds warm vintage tones inspired by old photographic prints. Perfect for nostalgic portraits, weddings, and timeless storytelling.',
  },
  {
    id: 'monochrome-g',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/monog-9.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Monochrome_G_Filter.jpg?v=1779881555',
    title: 'MONOCHROME + G FILTER',
    titleColor: '#d8d8d8',
    desc: 'The green filter balances skin tones and controls brightness for softer, more natural monochrome portraits.',
  },
  {
    id: 'monochrome-r',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/monor-9.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Monochrome_R_Filter.jpg?v=1779881555',
    title: 'MONOCHROME + R FILTER',
    titleColor: '#d8d8d8',
    desc: 'Boost contrast dramatically and darken blue skies with the red filter for bold, punchy monochrome photography.',
  },
  {
    id: 'monochrome-ye',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/monoye-9.webp?v=1779882674',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Monochrome_Ye_Filter.jpg?v=1779881555',
    title: 'MONOCHROME + Ye FILTER',
    titleColor: '#d8d8d8',
    desc: 'The yellow filter gently enhances contrast and adds depth to monochrome scenes while maintaining a natural look.',
  },
  {
    id: 'monochrome',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/monostd-9.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Monochrome.jpg?v=1779881555',
    title: 'MONOCHROME',
    titleColor: '#d8d8d8',
    desc: 'MONOCHROME offers clean black & white visuals with smooth digital tonal gradation. A versatile choice for everyday monochrome photography.',
  },
  {
    id: 'acros-g',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/acrosg-9.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Acros_G_filter.jpg?v=1779881555',
    title: 'ACROS + G FILTER',
    titleColor: '#dcdcdc',
    desc: 'Designed especially for portraits, the green filter softens skin tones and balances facial contrast for natural-looking monochrome images.',
  },
  {
    id: 'acros-r',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/acrosr-9_9e7903d1-5454-44ce-b9dd-43cf52151c4f.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Acros_R_filter.jpg?v=1779881555',
    title: 'ACROS + R FILTER',
    titleColor: '#dcdcdc',
    desc: 'The red filter dramatically enhances contrast and deepens skies for bold black & white imagery. Perfect for striking landscapes and high-impact monochrome shots.',
  },
  {
    id: 'acros-ye',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/acrosye-9_dd0d5797-9e2e-4c7b-8c4f-205a0053ba60.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Acros_Ye_filter.jpg?v=1779881555',
    title: 'ACROS + Ye FILTER',
    titleColor: '#dcdcdc',
    desc: 'This filter subtly boosts contrast and darkens skies while preserving natural tonal gradation. Ideal for nature and street photography in monochrome.',
  },
  {
    id: 'acros',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/acrosstd-9.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Acros.jpg?v=1779881555',
    title: 'ACROS',
    titleColor: '#dcdcdc',
    desc: 'ACROS delivers rich monochrome depth with refined grain and smooth tonal gradation. A perfect choice for artistic black & white photography.',
  },
  {
    id: 'eterna-bleach',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/eternabb-9_527a53ab-fc9b-47ea-aa11-4df9615d293d.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Eterna_Bleach.jpg?v=1779881555',
    title: 'ETERNA BLEACH BYPASS',
    titleColor: '#b7c6cc',
    desc: 'High contrast and low saturation create a bold cinematic look inspired by classic Japanese cinema. Perfect for urban landscapes, sci-fi moods, and dramatic storytelling.',
  },
  {
    id: 'eterna',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/etrna-9.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Eterna.jpg?v=1779881555',
    title: 'ETERNA',
    titleColor: '#b79968',
    desc: 'Originally designed for cinema, ETERNA offers muted colors and soft contrast for a cinematic visual style. Ideal for video, dramatic portraits, and architectural photography.',
  },
  {
    id: 'nostalgic-neg',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/nostalgicneg-9_24020e3e-6109-42dc-9a45-8840c21648b9.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Nostalgic_Neg.jpg?v=1779881555',
    title: 'NOSTALGIC Neg.',
    titleColor: '#ffb700',
    desc: 'Warm amber tones and cinematic shadows give NOSTALGIC Neg. a timeless, emotional feel. Great for portraits, street photography, and moments filled with nostalgia.',
  },
  {
    id: 'classic-neg',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/1_2x_ff917daa-c289-44a1-bea8-6b73ffd9fed3.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Classic_neg.jpg?v=1779881555',
    title: 'CLASSIC Neg.',
    titleColor: '#ffffff',
    desc: 'CLASSIC Neg. recreates the nostalgic charm of vintage photo albums with strong contrast and retro color shifts. Perfect for snapshots, memories, and everyday storytelling.',
  },
  {
    id: 'pro-neg-std',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/pronegstd-9_d694b3d8-1c08-477d-9489-7e46c2a1a219.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Pro_Negative_Standard.jpg?v=1779881555',
    title: 'PRO Neg. Std',
    titleColor: '#ffffff',
    desc: 'PRO Neg. Std delivers soft tones and balanced contrast for a natural studio-style look. Ideal for portraits, food, and controlled lighting setups.',
  },
  {
    id: 'pro-neg-hi',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/proneghi-9.webp?v=1779882674',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Pro_Negative_High.jpg?v=1779881555',
    title: 'PRO Neg. Hi',
    titleColor: '#ffffff',
    desc: 'PRO Neg. Hi enhances contrast while preserving detail, making it perfect for outdoor portraits and bright natural light. Clean, professional, and expressive.',
  },
  {
    id: 'reala-ace',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/realaace-5_e95b72ca-5455-4eaa-a012-e9b0bc58ea52.webp?v=1779882674',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Reala_Ace.jpg?v=1779881555',
    title: 'REALA ACE',
    titleColor: '#ffffff',
    desc: 'REALA ACE recreates everyday moments with soft shadows, controlled colors, and a natural analog feel. A versatile simulation ideal for snapshots, family moments, and daily life.',
  },
  {
    id: 'classic-chrome',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/classicchrome-7_1a64874e-1666-46cf-8d03-5ea997b7e101.webp?v=1779882674',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Classic_Chrome.jpg?v=1779881555',
    title: 'CLASSIC CHROME',
    titleColor: '#f1b12c',
    desc: 'Inspired by vintage photojournalism, CLASSIC CHROME offers muted tones and cinematic contrast for timeless storytelling. Perfect for street, fashion, and documentary-style photography.',
  },
  {
    id: 'astia',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Asset-3_4x-5.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Astia.jpg?v=1779881555',
    title: 'ASTIA',
    titleColor: '#ffffff',
    desc: 'ASTIA delivers soft tonal gradation with balanced saturation, making it ideal for portraits, weddings, and scenes with challenging lighting. Elegant, natural, and refined.',
  },
  {
    id: 'velvia',
    label: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/velvia-9.webp?v=1779882673',
    img: 'https://cdn.shopify.com/s/files/1/0951/4647/5815/files/Velvia.jpg?v=1779881555',
    title: 'VELVIA',
    titleColor: '#ffffff',
    desc: 'Bold, vibrant, and full of energy, Velvia brings landscapes, skies, and nature to life with rich colors and deep contrast. Perfect for dramatic visuals and expressive photography.',
  }
];

const TOTAL = SIMULATIONS.length;

const dial = document.getElementById('filmDial');
const dialInner = document.getElementById('dialInner');
const outputImg = document.getElementById('filmImage');
const outputLbl = document.getElementById('filmText');
const outputDesc = document.getElementById('sim_desc');

let isDragging = false;
let isSnapAnimating = false;
let currentFrame = 0;
let currentRotation = CONFIG.DIAL_OFFSET_DEG;
let lastX = 0;
let lastY = 0;
let lastTime = 0;
let velocity = 0;
let rotationHistory = [];
let renderTimer = null;
let snapTimer = null;

const cache = {
  imgs: new Array(TOTAL),
  lbls: new Array(TOTAL),
};

function normalizeFrame(index) {
  return ((index % TOTAL) + TOTAL) % TOTAL;
}

function normalizeRotation(deg) {
  return ((deg % 360) + 360) % 360;
}

function escapeHTML(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildDescriptionHTML(sim) {
  const color = sim.titleColor ? ` style="color:${escapeHTML(sim.titleColor)}"` : '';
  return `<h3${color}>${escapeHTML(sim.title)}</h3><p>${escapeHTML(sim.desc)}</p>`;
}

function preload() {
  return new Promise((resolve) => {
    let done = 0;
    const needed = TOTAL * 2;

    const tick = () => {
      done += 1;
      if (done >= needed) resolve();
    };

    SIMULATIONS.forEach((sim, i) => {
      const img = new Image();
      img.onload = tick;
      img.onerror = tick;
      img.src = sim.img;
      cache.imgs[i] = img;

      const lbl = new Image();
      lbl.onload = tick;
      lbl.onerror = tick;
      lbl.src = sim.label;
      cache.lbls[i] = lbl;
    });
  });
}

function setContent(sim) {
  outputImg.src = sim.img;
  outputLbl.src = sim.label;
  outputDesc.innerHTML = buildDescriptionHTML(sim);
}

function renderFrame(index, immediate = false) {
  const nextIndex = normalizeFrame(index);
  const sim = SIMULATIONS[nextIndex];

  if (nextIndex === currentFrame && immediate !== 'force') return;
  currentFrame = nextIndex;

  clearTimeout(renderTimer);

  if (immediate) {
    setContent(sim);
    return;
  }

  outputImg.style.opacity = '0';
  outputLbl.style.opacity = '0';
  outputDesc.style.opacity = '0';

  renderTimer = setTimeout(() => {
    setContent(sim);

    requestAnimationFrame(() => {
      outputImg.style.opacity = '1';
      outputLbl.style.opacity = '1';
      outputDesc.style.opacity = '1';
    });
  }, CONFIG.TRANSITION_MS);
}

function rotationToFrame(rotation) {
  const adjusted = rotation - CONFIG.DIAL_OFFSET_DEG;
  const raw = adjusted / CONFIG.DEGREES_PER_FRAME;
  return normalizeFrame(Math.round(raw));
}

function frameToRotation(frame) {
  return normalizeFrame(frame) * CONFIG.DEGREES_PER_FRAME + CONFIG.DIAL_OFFSET_DEG;
}

function pushHistory(delta) {
  rotationHistory.push(delta);
  if (rotationHistory.length > CONFIG.VELOCITY_WINDOW) {
    rotationHistory.shift();
  }
}

function dominantDirection() {
  if (!rotationHistory.length) return 0;
  const total = rotationHistory.reduce((sum, value) => sum + value, 0);
  return Math.sign(total);
}

function cancelSnapAnimation() {
  clearTimeout(snapTimer);
  dialInner.style.transition = 'none';
  isSnapAnimating = false;
}

function snapToFrame(target) {
  const normalizedTarget = normalizeFrame(target);
  const targetDeg = frameToRotation(normalizedTarget);
  const currentDeg = normalizeRotation(currentRotation);

  let snapDeg = targetDeg;

  if (currentDeg - targetDeg > 180) snapDeg += 360;
  if (targetDeg - currentDeg > 180) snapDeg -= 360;

  const diff = Math.abs(snapDeg - currentDeg);
  const duration = Math.min(
    CONFIG.SNAP_MAX_MS,
    CONFIG.SNAP_BASE_MS + Math.abs(velocity) * 60 + diff * 0.3
  );

  isSnapAnimating = true;
  dialInner.style.transition = `transform ${duration}ms ${CONFIG.SNAP_EASING}`;
  dialInner.style.transform = `rotate(${snapDeg}deg)`;
  currentRotation = snapDeg;

  renderFrame(normalizedTarget, true);

  snapTimer = setTimeout(() => {
    isSnapAnimating = false;
    currentRotation = frameToRotation(normalizedTarget);
    dialInner.style.transition = 'none';
    dialInner.style.transform = `rotate(${currentRotation}deg)`;
  }, duration + 10);
}

function getPoint(e) {
  const source = e.touches ? e.touches[0] : e;
  return {
    x: source.clientX,
    y: source.clientY,
    time: Date.now(),
  };
}

function onDragStart(e) {
  if (e.button === 2) return;
  e.preventDefault();

  if (isSnapAnimating) cancelSnapAnimation();

  isDragging = true;
  velocity = 0;
  rotationHistory = [];

  const point = getPoint(e);
  lastX = point.x;
  lastY = point.y;
  lastTime = point.time;

  dialInner.style.transition = 'none';
}

function onDragMove(e) {
  if (!isDragging) return;
  e.preventDefault();

  const point = getPoint(e);
  const rect = dial.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;

  const prevAngle = Math.atan2(lastY - centerY, lastX - centerX);
  const currAngle = Math.atan2(point.y - centerY, point.x - centerX);

  let delta = currAngle - prevAngle;
  if (delta > Math.PI) delta -= 2 * Math.PI;
  if (delta < -Math.PI) delta += 2 * Math.PI;

  const deltaTime = Math.max(1, point.time - lastTime);
  const rawVelocity = delta / (deltaTime / 1000);
  velocity = rawVelocity * 0.4 + velocity * 0.6;

  const degreesDelta = delta * (180 / Math.PI);
  pushHistory(degreesDelta);

  const speed = Math.abs(degreesDelta);
  const smoothing = Math.max(0.3, Math.min(0.85, speed / 15));
  currentRotation = normalizeRotation(currentRotation + degreesDelta * smoothing);

  dialInner.style.transform = `rotate(${currentRotation}deg)`;
  renderFrame(rotationToFrame(currentRotation), Math.abs(velocity) < 0.3);

  lastX = point.x;
  lastY = point.y;
  lastTime = point.time;
}

function onDragEnd() {
  if (!isDragging) return;
  isDragging = false;

  const frame = rotationToFrame(currentRotation);
  const direction = dominantDirection();
  const bias =
    Math.abs(velocity) < 0.1 ? 0 : direction * 0.2 * Math.min(1, Math.abs(velocity));

  const target = normalizeFrame(Math.round(frame + bias));
  snapToFrame(target);
}

function bindEvents() {
  dial.addEventListener('mousedown', onDragStart);
  dial.addEventListener('touchstart', onDragStart, { passive: false });

  document.addEventListener('mousemove', onDragMove);
  document.addEventListener('touchmove', onDragMove, { passive: false });

  document.addEventListener('mouseup', onDragEnd);
  document.addEventListener('touchend', onDragEnd);
  document.addEventListener('touchcancel', onDragEnd);

  dial.addEventListener('contextmenu', (e) => e.preventDefault());
}

(function init() {
  const transition = `opacity ${CONFIG.TRANSITION_MS}ms ease-out`;

  outputImg.style.transition = transition;
  outputLbl.style.transition = transition;
  outputDesc.style.transition = transition;

  outputImg.style.opacity = '0';
  outputLbl.style.opacity = '0';
  outputDesc.style.opacity = '0';

  dialInner.style.transition = 'none';
  dialInner.style.transform = `rotate(${CONFIG.DIAL_OFFSET_DEG}deg)`;

  bindEvents();

  preload().then(() => {
    renderFrame(0, 'force');
    requestAnimationFrame(() => {
      outputImg.style.opacity = '1';
      outputLbl.style.opacity = '1';
      outputDesc.style.opacity = '1';
    });
  });
})();
